import * as React from "react";

interface GenControlsBarProps {
  children: React.ReactNode;
}

export default function GenControlsBar(
  {
    children,
  }: GenControlsBarProps,
) {
  return (
    <div className="gen-controls-bar">
      {children}
    </div>
  );
}
